import sprite1 from './aa3085ccc742c84f5f99c2fd150fb596.svg';
import sprite2 from './af5b4ee04f18feedd3729336a0640ef4.svg';

export default [
    {
        name: 'Calliope',
        tags: ['board', 'calliope'],
        isStage: false,
        variables: {},
        costumes: [
            {
                assetId: 'aa3085ccc742c84f5f99c2fd150fb596',
                name: 'calliope-a',
                bitmapResolution: 1,
                rawUrl: sprite1,
                dataFormat: 'svg',
                rotationCenterX: 150,
                rotationCenterY: 150
            },
            {
                assetId: 'af5b4ee04f18feedd3729336a0640ef4',
                name: 'calliope-b',
                bitmapResolution: 1,
                rawUrl: sprite2,
                dataFormat: 'svg',
                rotationCenterX: 150,
                rotationCenterY: 150
            }
        ],
        sounds: [],
        blocks: {}
    }
];
